import React, {useContext, useEffect} from 'react';
import { BrowserContext } from '../utils/constants';

export default function UnsupportedBrowser()  {

  const browser = useContext(BrowserContext);

  useEffect(() => {
    document.title = 'Rise by TransAlta Unsupported Browser';
  }, []);

  let fullBrowserName;
  switch(browser.name) {
    case 'ie':
      fullBrowserName = 'Microsoft Internet Explorer';
      break;
    case 'edge':
      fullBrowserName = 'Microsoft Edge';
      break;
    default:
      fullBrowserName = 'Unsupported browser';
  }

  const message = `You are using ${fullBrowserName}. Please switch to Google Chrome or Mozilla Firefox browser for better user experience.`;

  document.getElementsByClassName('MuiButtonBase-root').forEach(e => e.style.display = 'none');
  document.getElementsByClassName('MuiSvgIcon-root').forEach(e => e.style.display = 'none');

  return (
    <main>
        <div style={{textAlign: 'center'}}><h2>{message}</h2></div>
    </main>
  );
}
